import { createTheme } from '@mui/material';

export const theme = createTheme({
    palette: {
        primary: {
            main: '#1BABE2'
        }
    },
    typography: {
        fontFamily: 'Montserrat',
        fontWeightLight: 400,
        fontWeightBold: 700,
        subtitle1: {
            fontFamily: 'Montserrat',
            fontStyle: 'normal',
            fontWeight: 500,
            fontSize: '13px',
            lineHeight: '20px',
            color: '#7D95A5'
        },
        subtitle2: {
            fontFamily: 'Montserrat',
            fontStyle: 'normal',
            fontWeight: 600,
            fontSize: '13px',
            lineHeight: '20px',
            color: '#225384',
            marginBottom: '4px'
        },
        subtitle3: {
            fontFamily: 'Montserrat',
            fontStyle: 'normal',
            fontWeight: 600,
            fontSize: '13px',
            lineHeight: '20px',
            color: '#7D95A5',
            marginBottom: '4px'
        },
        h6: {
            fontFamily: 'Montserrat',
            fontStyle: 'normal',
            fontWeight: 600,
            fontSize: '23px',
            lineHeight: '28px',
            color: '#182D55'
        },
        shippingAddress: {
            fontFamily: 'Montserrat',
            fontStyle: 'normal',
            fontWeight: 700,
            fontSize: '16px',
            lineHeight: '28px',
            color: '#182D55'
        },
        label: {
            fontFamily: 'Montserrat',
            fontStyle: 'normal',
            fontWeight: 500,
            fontSize: '14px',
            lineHeight: '17px',
            color: '#182D55',
            cursor: 'pointer'
        },
        labelAddress: {
            fontFamily: 'Montserrat',
            fontStyle: 'normal',
            fontWeight: 500,
            fontSize: '13px',
            lineHeight: '20px',
            color: '#182D55'
        },
        caption: {
            fontFamily: 'Montserrat',
            fontStyle: 'normal',
            fontWeight: 'normal',
            fontSize: '9px',
            lineHeight: '11px',
            textTransform: 'uppercase',
            color: '#7D95A5'
        },
        customText: {
            fontFamily: 'Montserrat',
            fontStyle: 'normal',
            fontWeight: 500,
            fontSize: '13px',
            lineHeight: '20px',
            color: '#1BABE2',
            cursor: 'pointer'
        },
        bannerTextSecondary: {
            fontFamily: 'Montserrat',
            fontStyle: 'normal',
            fontWeight: '800',
            fontSize: '17px',
            lineHeight: '21px',
            color: '#FFFFFF',
            textTransform: 'uppercase'
        },
        bannerTextPrimary: {
            marginTop: '7px',
            fontFamily: 'Montserrat',
            fontStyle: 'normal',
            fontWeight: '300',
            fontSize: '62px',
            lineHeight: '76px',
            color: '#FFFFFF'
        },
        bannerFooterText: {
            fontFamily: 'Montserrat',
            fontStyle: 'normal',
            fontWeight: 400,
            fontSize: '23px',
            lineHeight: '35px',
            color: '#FFFFFF',
            maxWidth: '636px'
        },
        headerOfBanner: {
            display: 'block',
            fontFamily: 'Montserrat',
            fontStyle: 'normal',
            fontWeight: 700,
            fontSize: '30px',
            lineHeight: '37px',
            color: '#182C55',
            marginBottom: '8px'
        },
        subHeaderOfBanner: {
            display: 'block',
            fontFamily: 'Montserrat',
            fontStyle: 'normal',
            fontWeight: 700,
            fontSize: '16px',
            lineHeight: '24px',
            color: '#182C55',
            marginBottom: '8px'
        },
        sidebarItem: {
            fontFamily: 'Montserrat',
            fontStyle: 'normal',
            fontWeight: 500,
            fontSize: '14px',
            lineHeight: '18.2px',
            color: '#A8B6C1'
        },
        selectedSidebarItem: {
            fontFamily: 'Montserrat',
            fontStyle: 'normal',
            fontWeight: 700,
            fontSize: '14px',
            lineHeight: '18.2px',
            color: '#FFFFFF'
        },
        customSelectText: {
            fontFamily: 'Montserrat',
            fontStyle: 'normal',
            fontWeight: 600,
            fontSize: '13px',
            lineHeight: '20px',
            color: '#182D55'
        },
        customSecondarySelect: {
            fontFamily: 'Montserrat',
            fontStyle: 'normal',
            fontWeight: 'normal',
            fontSize: '12px',
            lineHeight: '16px',
            color: '#7D95A5'
        }
    },
    components: {
        MuiOutlinedInput: {
            styleOverrides: {
                root: {
                    fontSize: 14,
                    fontWeight: 500,
                    borderRadius: 4,
                    fontcolor: '#182D55'
                },
                input: {
                    fontSize: 14,
                    fontWeight: 500,
                    borderRadius: 4,
                    fontcolor: '#182D55'
                }
            }
        },
        MuiButton: {
            styleOverrides: {
                outlined: {
                    textTransform: 'capitalize',
                    height: '40px',
                    borderRadius: '4px',
                    fontSize: '13px',
                    padding: '10px 36px',
                    border: '1px solid #1BABE2'
                },
                contained: {
                    textTransform: 'capitalize',
                    height: '40px',
                    borderRadius: '4px',
                    fontSize: '13px',
                    padding: '10px 36px',
                    color: 'white'
                },
                text: {
                    textTransform: 'capitalize'
                }
            }
        },
        MuiButtonBase: {
            styleOverrides: {
                root: {
                    '&.Mui-disabled': {
                        color: 'white'
                    }
                }
            }
        }
        // MuiInputBase: {
        //     styleOverrides: {
        //         root: {
        //             paddingTop: 5,
        //             paddingBottom: 5,
        //             height: 40
        //         }
        //     }
        // },
        // MuiAutocomplete: {
        //     styleOverrides: {
        //         input: {
        //             height: 'auto',
        //             padding: '0!important'
        //         }
        //     }
        // }
    }
});
